import { ApiClientError, api } from '@/lib/api';
import {
    createOrganizationInputSchema,
    organizationSchema,
    organizationsListSchema,
    type CreateOrganizationInput,
    type Organization
} from '../api/schemas';

export async function listOrganizations(): Promise<Organization[]> {
    try {
        const rawResponse = await api.get('/v1/organizations', { authenticated: true });
        return organizationsListSchema.parse(rawResponse);
    } catch (error) {
        if (error instanceof ApiClientError && error.status === 404) {
            return [];
        }

        throw error;
    }
}

export async function createOrganization(input: CreateOrganizationInput): Promise<Organization> {
    const payload = createOrganizationInputSchema.parse(input);

    const rawResponse = await api.post(
        '/v1/organizations',
        {
            name: payload.name.trim(),
            ...(payload.slug?.trim() ? { slug: payload.slug.trim() } : {})
        },
        { authenticated: true }
    );

    return organizationSchema.parse(rawResponse);
}
